import { View, ProgressView, PLATFORM_OVERLAY_SMALL } from "@gaming/srvg-classes-core";
import { LivetableLeagueWidget } from "../../../widgets/View/VfWidget/LivetableLeagueWidget";

export class PostLeagueOverlay extends View {

    livetableLeagueWidget: LivetableLeagueWidget;
    progressView: ProgressView;

    constructor( options ) {
        options = options || {};
        super( options );

        this.livetableLeagueWidget = null;

        if( srvg.widgets.enabled ) {
            // livetable league, if it is enabled in configuration file, while cuproster os not
            if (srvg.widgets.widgets['livetableLeague'].enabled) {
                this.livetableLeagueWidget = this.addSubView(new LivetableLeagueWidget({
                    selector: '#post_league_overlay .tournamentroster',
                    platform: PLATFORM_OVERLAY_SMALL
                }));
            }
        }
        this.progressView = this.addSubView( new ProgressView( { selector: this.selector + ' .progressView'} ) );
    }
}